/**
 * @generated SignedSource<<6086ee58546a7f12105984e31d35effc>>
 * @relayHash 327d7a25f6f7a434b4c1b6554dc4ec68
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 327d7a25f6f7a434b4c1b6554dc4ec68

import type { ConcreteRequest } from 'relay-runtime';
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTimelineItemsItemType = "ADDED_TO_PROJECT_EVENT" | "ADDED_TO_PROJECT_V2_EVENT" | "ASSIGNED_EVENT" | "BLOCKED_BY_ADDED_EVENT" | "BLOCKED_BY_REMOVED_EVENT" | "BLOCKING_ADDED_EVENT" | "BLOCKING_REMOVED_EVENT" | "CLOSED_EVENT" | "COMMENT_DELETED_EVENT" | "CONNECTED_EVENT" | "CONVERTED_FROM_DRAFT_EVENT" | "CONVERTED_NOTE_TO_ISSUE_EVENT" | "CONVERTED_TO_DISCUSSION_EVENT" | "CROSS_REFERENCED_EVENT" | "DEMILESTONED_EVENT" | "DISCONNECTED_EVENT" | "ISSUE_COMMENT" | "ISSUE_COMMENT_PINNED_EVENT" | "ISSUE_COMMENT_UNPINNED_EVENT" | "ISSUE_FIELD_ADDED_EVENT" | "ISSUE_FIELD_CHANGED_EVENT" | "ISSUE_FIELD_REMOVED_EVENT" | "ISSUE_TYPE_ADDED_EVENT" | "ISSUE_TYPE_CHANGED_EVENT" | "ISSUE_TYPE_REMOVED_EVENT" | "LABELED_EVENT" | "LOCKED_EVENT" | "MARKED_AS_DUPLICATE_EVENT" | "MENTIONED_EVENT" | "MILESTONED_EVENT" | "MOVED_COLUMNS_IN_PROJECT_EVENT" | "PARENT_ISSUE_ADDED_EVENT" | "PARENT_ISSUE_REMOVED_EVENT" | "PINNED_EVENT" | "PROJECT_V2_ITEM_STATUS_CHANGED_EVENT" | "REFERENCED_EVENT" | "RELATES_TO_ADDED_EVENT" | "RELATES_TO_REMOVED_EVENT" | "REMOVED_FROM_PROJECT_EVENT" | "REMOVED_FROM_PROJECT_V2_EVENT" | "RENAMED_TITLE_EVENT" | "REOPENED_EVENT" | "SUBSCRIBED_EVENT" | "SUB_ISSUE_ADDED_EVENT" | "SUB_ISSUE_REMOVED_EVENT" | "TRANSFERRED_EVENT" | "UNASSIGNED_EVENT" | "UNLABELED_EVENT" | "UNLOCKED_EVENT" | "UNMARKED_AS_DUPLICATE_EVENT" | "UNPINNED_EVENT" | "UNSUBSCRIBED_EVENT" | "USER_BLOCKED_EVENT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type LockReason = "OFF_TOPIC" | "RESOLVED" | "SPAM" | "TOO_HEATED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type UserBlockDuration = "ONE_DAY" | "ONE_MONTH" | "ONE_WEEK" | "PERMANENT" | "THREE_DAYS" | "%future added value";
export type IssueViewerSubscriptionTimelineSubscription$variables = {
  connections: ReadonlyArray<string>;
  issueId: string;
  itemTypes?: ReadonlyArray<IssueTimelineItemsItemType> | null | undefined;
  skip?: number | null | undefined;
};
export type IssueViewerSubscriptionTimelineSubscription$data = {
  readonly issueUpdated: {
    readonly issue: {
      readonly number: number;
      readonly repository: {
        readonly name: string;
        readonly owner: {
          readonly login: string;
        };
      };
    };
    readonly issueTimelineUpdated: {
      readonly timelineItems: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly __id: string;
            readonly actor?: {
              readonly __typename: string;
              readonly avatarUrl: string;
              readonly displayName?: string;
              readonly isAgent?: boolean;
              readonly isCopilot?: boolean;
              readonly login: string;
              readonly name?: string | null | undefined;
              readonly profileResourcePath: string | null | undefined;
            } | null | undefined;
            readonly assignee?: {
              readonly __typename: "Bot";
              readonly displayName?: string;
              readonly isAgent?: boolean;
              readonly isCopilot?: boolean;
              readonly login?: string;
              readonly name?: string | null | undefined;
              readonly resourcePath?: string;
            } | null | undefined;
            readonly author?: {
              readonly __typename: string;
              readonly avatarUrl: string;
              readonly id: string;
              readonly login: string;
              readonly name?: string | null | undefined;
            } | null | undefined;
            readonly authorAssociation?: CommentAuthorAssociation;
            readonly authorToRepoOwnerSponsorship?: {
              readonly createdAt: string;
              readonly isActive: boolean;
            } | null | undefined;
            readonly blockDuration?: UserBlockDuration;
            readonly blockedIssue?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly blockedUser?: {
              readonly login: string;
              readonly name: string | null | undefined;
            } | null | undefined;
            readonly blockingIssue?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly body?: string;
            readonly bodyHTML?: string;
            readonly bodyVersion?: string;
            readonly canonical?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly closer?: {
              readonly __typename: "Commit";
              readonly abbreviatedOid: string;
              readonly repository: {
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | {
              readonly __typename: "ProjectV2";
              readonly title: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly closingProjectItemStatus?: string | null | undefined;
            readonly color?: string | null | undefined;
            readonly commit?: {
              readonly abbreviatedOid: string;
              readonly message: string;
              readonly messageBodyHTML: string;
              readonly messageHeadlineHTML: string;
              readonly repository: {
                readonly defaultBranch: string;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly url: string;
            } | null | undefined;
            readonly createdAt?: string;
            readonly createdViaEmail?: boolean;
            readonly currentTitle?: string;
            readonly databaseId?: number | null | undefined;
            readonly deletedCommentAuthor?: {
              readonly __typename: string;
              readonly login: string;
              readonly name?: string | null | undefined;
            } | null | undefined;
            readonly discussion?: {
              readonly number: number;
              readonly url: string;
            } | null | undefined;
            readonly duplicate?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly duplicateOf?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly fromRepository?: {
              readonly nameWithOwner: string;
              readonly url: string;
            } | null | undefined;
            readonly id?: string;
            readonly innerSource?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | {
              readonly __typename: "PullRequest";
              readonly id: string;
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly pullTitleHTML: string;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly intent?: {
              readonly rationale: string | null | undefined;
            } | null | undefined;
            readonly isCanonicalOfClosedDuplicate?: boolean | null | undefined;
            readonly isHidden?: boolean;
            readonly issue?: {
              readonly author: {
                readonly login: string;
              } | null | undefined;
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly locked: boolean;
              readonly number: number;
            };
            readonly issueComment?: {
              readonly databaseId: number | null | undefined;
              readonly url: string;
            } | null | undefined;
            readonly issueField?: {
              readonly dataType?: IssueFieldDataType;
              readonly name?: string;
            } | null | undefined;
            readonly issueType?: {
              readonly color: IssueTypeColor;
              readonly name: string;
            } | null | undefined;
            readonly label?: {
              readonly archivedAt: string | null | undefined;
              readonly color: string;
              readonly description: string | null | undefined;
              readonly id: string;
              readonly name: string;
              readonly nameHTML: string;
            };
            readonly lastEditedAt?: string | null | undefined;
            readonly lastUserContentEdit?: {
              readonly editor: {
                readonly login: string;
                readonly url: string;
              } | null | undefined;
            } | null | undefined;
            readonly lockReason?: LockReason | null | undefined;
            readonly milestone?: {
              readonly url: string;
            } | null | undefined;
            readonly milestoneTitle?: string;
            readonly minimizedReason?: string | null | undefined;
            readonly newColor?: string | null | undefined;
            readonly newOptions?: ReadonlyArray<{
              readonly color: string | null | undefined;
              readonly name: string;
            }> | null | undefined;
            readonly newValue?: string | null | undefined;
            readonly options?: ReadonlyArray<{
              readonly color: string | null | undefined;
              readonly name: string;
            }> | null | undefined;
            readonly parent?: {
              readonly __typename: "Issue";
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly pendingBlock?: boolean | null | undefined;
            readonly pendingMinimizeReason?: string | null | undefined;
            readonly pendingUnblock?: boolean | null | undefined;
            readonly pinnedBy?: {
              readonly login: string;
            } | null | undefined;
            readonly prevIssueType?: {
              readonly color: IssueTypeColor;
              readonly name: string;
            } | null | undefined;
            readonly previousStatus?: string;
            readonly previousTitle?: string;
            readonly project?: {
              readonly title: string;
              readonly url: string;
            } | null | undefined;
            readonly reactionGroups?: ReadonlyArray<{
              readonly content: ReactionContent;
              readonly reactors: {
                readonly nodes: ReadonlyArray<{
                  readonly __typename: string;
                  readonly avatarUrl?: string;
                  readonly displayName?: string;
                  readonly isAgent?: boolean;
                  readonly isCopilot?: boolean;
                  readonly login?: string;
                  readonly name?: string | null | undefined;
                } | null | undefined> | null | undefined;
                readonly totalCount: number;
              };
              readonly viewerHasReacted: boolean;
            }> | null | undefined;
            readonly referencedAt?: string;
            readonly relatedIssue?: {
              readonly __typename: "Issue";
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly repository?: {
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly isPrivate: boolean;
              readonly name: string;
              readonly nameWithOwner: string;
              readonly owner: {
                readonly id: string;
                readonly login: string;
                readonly url: string;
              };
              readonly slashCommandsEnabled: boolean;
              readonly viewerCanCreateIssues: boolean;
            };
            readonly showSpammyBadge?: boolean;
            readonly stateReason?: IssueStateReason | null | undefined;
            readonly status?: string;
            readonly subIssue?: {
              readonly __typename: "Issue";
              readonly databaseId: number | null | undefined;
              readonly id: string;
              readonly number: number;
              readonly repository: {
                readonly id: string;
                readonly isPrivate: boolean;
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly stateReason: IssueStateReason | null | undefined;
              readonly titleHTML: string;
              readonly url: string;
            } | null | undefined;
            readonly subject?: {
              readonly __typename: "PullRequest";
              readonly isDraft: boolean;
              readonly isInMergeQueue: boolean;
              readonly number: number;
              readonly repository: {
                readonly name: string;
                readonly owner: {
                  readonly login: string;
                };
              };
              readonly state: PullRequestState;
              readonly title: string;
              readonly url: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly url?: string;
            readonly value?: string | null | undefined;
            readonly viaApp?: {
              readonly name: string;
              readonly url: string;
            } | null | undefined;
            readonly viewerCanBlockFromOrg?: boolean;
            readonly viewerCanBlockPersonally?: boolean;
            readonly viewerCanDelete?: boolean;
            readonly viewerCanMinimize?: boolean;
            readonly viewerCanPin?: boolean;
            readonly viewerCanReadUserContentEdits?: boolean;
            readonly viewerCanReport?: boolean;
            readonly viewerCanReportToMaintainer?: boolean;
            readonly viewerCanUnblockFromOrg?: boolean;
            readonly viewerCanUnblockPersonally?: boolean;
            readonly viewerCanUndo?: boolean;
            readonly viewerCanUnminimize?: boolean;
            readonly viewerCanUnpin?: boolean;
            readonly viewerCanUpdate?: boolean;
            readonly viewerDidAuthor?: boolean;
            readonly willCloseSubject?: boolean;
            readonly willCloseTarget?: boolean;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly totalCount: number;
      };
    } | null | undefined;
  };
};
export type IssueViewerSubscriptionTimelineSubscription = {
  response: IssueViewerSubscriptionTimelineSubscription$data;
  variables: IssueViewerSubscriptionTimelineSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemTypes"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v8 = [
  (v7/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v8/*:: as any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v12 = [
  (v11/*:: as any*/),
  {
    "kind": "Variable",
    "name": "itemTypes",
    "variableName": "itemTypes"
  },
  {
    "kind": "Variable",
    "name": "skip",
    "variableName": "skip"
  },
  {
    "kind": "Literal",
    "name": "visibleEventsOnly",
    "value": true
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*:: as any*/),
    (v20/*:: as any*/),
    (v21/*:: as any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v23 = [
  (v6/*:: as any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": (v23/*:: as any*/),
  "type": "User",
  "abstractKey": null
},
v25 = {
  "kind": "InlineFragment",
  "selections": (v23/*:: as any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v26 = {
  "kind": "InlineFragment",
  "selections": (v23/*:: as any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v17/*:: as any*/),
    (v7/*:: as any*/),
    (v18/*:: as any*/),
    (v14/*:: as any*/),
    (v22/*:: as any*/),
    (v24/*:: as any*/),
    (v25/*:: as any*/),
    (v26/*:: as any*/)
  ],
  "storageKey": null
},
v28 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v27/*:: as any*/)
],
v29 = [
  (v16/*:: as any*/),
  (v15/*:: as any*/),
  (v27/*:: as any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorAssociation",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanMinimize",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnminimize",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReport",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReportToMaintainer",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockFromOrg",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockFromOrg",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockPersonally",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockPersonally",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPin",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSpammyBadge",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdViaEmail",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReadUserContentEdits",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastEditedAt",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v30/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    },
    (v7/*:: as any*/),
    (v14/*:: as any*/),
    (v24/*:: as any*/),
    (v25/*:: as any*/),
    (v26/*:: as any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locked",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v56 = {
  "alias": "isHidden",
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanCreateIssues",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slashCommandsEnabled",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasReacted",
  "storageKey": null
},
v64 = [
  (v11/*:: as any*/)
],
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*:: as any*/),
    (v6/*:: as any*/),
    (v17/*:: as any*/),
    (v22/*:: as any*/)
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "ReactionGroup",
  "kind": "LinkedField",
  "name": "reactionGroups",
  "plural": true,
  "selections": [
    (v62/*:: as any*/),
    (v63/*:: as any*/),
    {
      "alias": null,
      "args": (v64/*:: as any*/),
      "concreteType": "ReactorConnection",
      "kind": "LinkedField",
      "name": "reactors",
      "plural": false,
      "selections": [
        (v13/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v14/*:: as any*/),
            (v65/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reactors(first:10)"
    }
  ],
  "storageKey": null
},
v67 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingMinimizeReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingBlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingUnblock",
      "storageKey": null
    }
  ]
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v30/*:: as any*/),
    (v6/*:: as any*/),
    (v58/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v75 = [
  (v14/*:: as any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v30/*:: as any*/),
      (v69/*:: as any*/),
      (v31/*:: as any*/),
      (v5/*:: as any*/),
      (v68/*:: as any*/),
      (v70/*:: as any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v30/*:: as any*/),
      (v71/*:: as any*/),
      (v31/*:: as any*/),
      (v5/*:: as any*/),
      (v72/*:: as any*/),
      (v73/*:: as any*/),
      (v74/*:: as any*/),
      (v70/*:: as any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingProjectItemStatus",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*:: as any*/),
    (v77/*:: as any*/)
  ],
  "type": "ProjectV2",
  "abstractKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockReason",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v6/*:: as any*/),
    (v82/*:: as any*/),
    (v30/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archivedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentTitle",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousTitle",
  "storageKey": null
},
v86 = {
  "kind": "InlineFragment",
  "selections": (v8/*:: as any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v88 = [
  (v14/*:: as any*/),
  (v7/*:: as any*/),
  (v87/*:: as any*/),
  (v6/*:: as any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v86/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": (v88/*:: as any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v88/*:: as any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*:: as any*/),
        (v7/*:: as any*/),
        (v87/*:: as any*/)
      ],
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*:: as any*/),
        (v7/*:: as any*/),
        (v87/*:: as any*/),
        (v19/*:: as any*/),
        (v21/*:: as any*/),
        (v20/*:: as any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockDuration",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referencedAt",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseTarget",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "milestoneTitle",
  "storageKey": null
},
v94 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v27/*:: as any*/),
  (v93/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v31/*:: as any*/)
    ],
    "storageKey": null
  }
],
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseSubject",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageHeadlineHTML",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageBodyHTML",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultBranch",
  "storageKey": null
},
v100 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v14/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v77/*:: as any*/),
          (v31/*:: as any*/),
          (v5/*:: as any*/),
          (v72/*:: as any*/),
          (v73/*:: as any*/),
          (v74/*:: as any*/),
          (v10/*:: as any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v101 = [
  (v14/*:: as any*/),
  (v30/*:: as any*/),
  (v69/*:: as any*/),
  (v31/*:: as any*/),
  (v5/*:: as any*/),
  (v68/*:: as any*/),
  (v70/*:: as any*/)
],
v102 = [
  {
    "kind": "InlineFragment",
    "selections": (v101/*:: as any*/),
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v14/*:: as any*/),
      (v30/*:: as any*/),
      (v71/*:: as any*/),
      (v31/*:: as any*/),
      (v5/*:: as any*/),
      (v72/*:: as any*/),
      (v73/*:: as any*/),
      (v74/*:: as any*/),
      (v70/*:: as any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v102/*:: as any*/),
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUndo",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v77/*:: as any*/),
    (v31/*:: as any*/)
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousStatus",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v109 = [
  (v14/*:: as any*/),
  (v30/*:: as any*/),
  (v69/*:: as any*/),
  (v31/*:: as any*/),
  (v5/*:: as any*/),
  (v68/*:: as any*/),
  (v70/*:: as any*/),
  (v15/*:: as any*/)
],
v110 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v109/*:: as any*/),
    "storageKey": null
  }
],
v111 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v109/*:: as any*/),
    "storageKey": null
  }
],
v112 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v101/*:: as any*/),
    "storageKey": null
  }
],
v113 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v101/*:: as any*/),
    "storageKey": null
  }
],
v114 = [
  (v15/*:: as any*/),
  (v27/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "relatedIssue",
    "plural": false,
    "selections": (v101/*:: as any*/),
    "storageKey": null
  }
],
v115 = [
  (v6/*:: as any*/),
  (v82/*:: as any*/)
],
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v115/*:: as any*/),
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v118 = {
  "kind": "InlineFragment",
  "selections": [
    (v117/*:: as any*/),
    (v6/*:: as any*/)
  ],
  "type": "IssueFieldText",
  "abstractKey": null
},
v119 = [
  (v6/*:: as any*/),
  (v117/*:: as any*/)
],
v120 = {
  "kind": "InlineFragment",
  "selections": (v119/*:: as any*/),
  "type": "IssueFieldDate",
  "abstractKey": null
},
v121 = {
  "kind": "InlineFragment",
  "selections": (v119/*:: as any*/),
  "type": "IssueFieldNumber",
  "abstractKey": null
},
v122 = {
  "kind": "InlineFragment",
  "selections": (v119/*:: as any*/),
  "type": "IssueFieldSingleSelect",
  "abstractKey": null
},
v123 = {
  "kind": "InlineFragment",
  "selections": (v119/*:: as any*/),
  "type": "IssueFieldMultiSelect",
  "abstractKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v118/*:: as any*/),
    (v120/*:: as any*/),
    (v121/*:: as any*/),
    (v122/*:: as any*/),
    (v123/*:: as any*/)
  ],
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newColor",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "newOptions",
  "plural": true,
  "selections": (v115/*:: as any*/),
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newValue",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueFieldTimelineOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": (v115/*:: as any*/),
  "storageKey": null
},
v129 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v130 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v27/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v31/*:: as any*/),
      (v15/*:: as any*/)
    ],
    "storageKey": null
  }
],
v131 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v132 = [
  (v14/*:: as any*/),
  (v7/*:: as any*/),
  (v30/*:: as any*/)
],
v133 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v132/*:: as any*/),
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v6/*:: as any*/),
    (v133/*:: as any*/),
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v17/*:: as any*/),
    (v7/*:: as any*/),
    (v18/*:: as any*/),
    (v14/*:: as any*/),
    (v22/*:: as any*/),
    (v24/*:: as any*/),
    (v25/*:: as any*/),
    (v26/*:: as any*/),
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v136 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v135/*:: as any*/)
],
v137 = [
  (v16/*:: as any*/),
  (v15/*:: as any*/),
  (v135/*:: as any*/)
],
v138 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v139 = {
  "alias": null,
  "args": null,
  "concreteType": "ReactionGroup",
  "kind": "LinkedField",
  "name": "reactionGroups",
  "plural": true,
  "selections": [
    (v62/*:: as any*/),
    (v63/*:: as any*/),
    {
      "alias": null,
      "args": (v64/*:: as any*/),
      "concreteType": "ReactorConnection",
      "kind": "LinkedField",
      "name": "reactors",
      "plural": false,
      "selections": [
        (v13/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v14/*:: as any*/),
            (v65/*:: as any*/),
            (v138/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reactors(first:10)"
    }
  ],
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v30/*:: as any*/),
    (v6/*:: as any*/),
    (v58/*:: as any*/),
    (v133/*:: as any*/)
  ],
  "storageKey": null
},
v141 = [
  (v14/*:: as any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v30/*:: as any*/),
      (v69/*:: as any*/),
      (v31/*:: as any*/),
      (v5/*:: as any*/),
      (v68/*:: as any*/),
      (v140/*:: as any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v30/*:: as any*/),
      (v71/*:: as any*/),
      (v31/*:: as any*/),
      (v5/*:: as any*/),
      (v72/*:: as any*/),
      (v73/*:: as any*/),
      (v74/*:: as any*/),
      (v140/*:: as any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v138/*:: as any*/)
],
v142 = [
  (v7/*:: as any*/),
  (v87/*:: as any*/),
  (v6/*:: as any*/)
],
v143 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v14/*:: as any*/),
    (v86/*:: as any*/),
    {
      "kind": "InlineFragment",
      "selections": (v142/*:: as any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v142/*:: as any*/),
      "type": "Mannequin",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*:: as any*/),
        (v87/*:: as any*/)
      ],
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v7/*:: as any*/),
        (v87/*:: as any*/),
        (v19/*:: as any*/),
        (v21/*:: as any*/),
        (v20/*:: as any*/)
      ],
      "type": "Bot",
      "abstractKey": null
    },
    (v138/*:: as any*/)
  ],
  "storageKey": null
},
v144 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v135/*:: as any*/),
  (v93/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v31/*:: as any*/),
      (v30/*:: as any*/)
    ],
    "storageKey": null
  }
],
v145 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v14/*:: as any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v77/*:: as any*/),
          (v31/*:: as any*/),
          (v5/*:: as any*/),
          (v72/*:: as any*/),
          (v73/*:: as any*/),
          (v74/*:: as any*/),
          (v134/*:: as any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v138/*:: as any*/)
    ],
    "storageKey": null
  }
],
v146 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v141/*:: as any*/),
  "storageKey": null
},
v147 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v77/*:: as any*/),
    (v31/*:: as any*/),
    (v30/*:: as any*/)
  ],
  "storageKey": null
},
v148 = [
  (v14/*:: as any*/),
  (v30/*:: as any*/),
  (v69/*:: as any*/),
  (v31/*:: as any*/),
  (v5/*:: as any*/),
  (v68/*:: as any*/),
  (v140/*:: as any*/),
  (v15/*:: as any*/)
],
v149 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v148/*:: as any*/),
    "storageKey": null
  }
],
v150 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v148/*:: as any*/),
    "storageKey": null
  }
],
v151 = [
  (v14/*:: as any*/),
  (v30/*:: as any*/),
  (v69/*:: as any*/),
  (v31/*:: as any*/),
  (v5/*:: as any*/),
  (v68/*:: as any*/),
  (v140/*:: as any*/)
],
v152 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockingIssue",
    "plural": false,
    "selections": (v151/*:: as any*/),
    "storageKey": null
  }
],
v153 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v151/*:: as any*/),
    "storageKey": null
  }
],
v154 = [
  (v15/*:: as any*/),
  (v135/*:: as any*/),
  (v16/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "relatedIssue",
    "plural": false,
    "selections": (v151/*:: as any*/),
    "storageKey": null
  }
],
v155 = [
  (v6/*:: as any*/),
  (v82/*:: as any*/),
  (v30/*:: as any*/)
],
v156 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v155/*:: as any*/),
  "storageKey": null
},
v157 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v14/*:: as any*/),
    (v118/*:: as any*/),
    (v120/*:: as any*/),
    (v121/*:: as any*/),
    (v122/*:: as any*/),
    (v123/*:: as any*/),
    (v138/*:: as any*/)
  ],
  "storageKey": null
},
v158 = [
  (v15/*:: as any*/),
  (v16/*:: as any*/),
  (v135/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v31/*:: as any*/),
      (v15/*:: as any*/),
      (v30/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v10/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTimelineUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "SubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*:: as any*/),
                            "type": "UnsubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v29/*:: as any*/),
                            "type": "MentionedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*:: as any*/),
                              (v15/*:: as any*/),
                              (v31/*:: as any*/),
                              (v16/*:: as any*/),
                              (v32/*:: as any*/),
                              (v33/*:: as any*/),
                              (v34/*:: as any*/),
                              (v35/*:: as any*/),
                              (v36/*:: as any*/),
                              (v37/*:: as any*/),
                              (v38/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              (v42/*:: as any*/),
                              (v43/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  (v31/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v16/*:: as any*/),
                                  (v48/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v49/*:: as any*/),
                              (v50/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v7/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": (v8/*:: as any*/),
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  (v30/*:: as any*/),
                                  (v5/*:: as any*/),
                                  (v52/*:: as any*/),
                                  (v15/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v8/*:: as any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v53/*:: as any*/),
                              (v54/*:: as any*/),
                              (v55/*:: as any*/),
                              (v56/*:: as any*/),
                              (v57/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v30/*:: as any*/),
                                  (v6/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v30/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v31/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v58/*:: as any*/),
                                  (v59/*:: as any*/),
                                  (v60/*:: as any*/),
                                  (v61/*:: as any*/),
                                  (v15/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v66/*:: as any*/),
                              (v67/*:: as any*/)
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v66/*:: as any*/)
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v68/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v75/*:: as any*/),
                                "storageKey": null
                              },
                              (v76/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v78/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v5/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v30/*:: as any*/),
                                          (v6/*:: as any*/),
                                          (v9/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v79/*:: as any*/),
                                      (v10/*:: as any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v27/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "ReopenedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v81/*:: as any*/),
                              (v27/*:: as any*/)
                            ],
                            "type": "LockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "UnlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "PinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "UnpinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v83/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "LabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v84/*:: as any*/),
                              (v85/*:: as any*/)
                            ],
                            "type": "RenamedTitleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v83/*:: as any*/)
                            ],
                            "type": "UnlabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v89/*:: as any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v89/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v7/*:: as any*/),
                                  (v24/*:: as any*/),
                                  (v26/*:: as any*/),
                                  (v25/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v90/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v6/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v91/*:: as any*/),
                              (v92/*:: as any*/),
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v75/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v94/*:: as any*/),
                            "type": "MilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v94/*:: as any*/),
                            "type": "DemilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*:: as any*/),
                              (v15/*:: as any*/),
                              (v95/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v27/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v96/*:: as any*/),
                                  (v97/*:: as any*/),
                                  (v98/*:: as any*/),
                                  (v31/*:: as any*/),
                                  (v79/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v6/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v99/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v16/*:: as any*/)
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*:: as any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v61/*:: as any*/),
                                  (v31/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*:: as any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v102/*:: as any*/),
                                "storageKey": null
                              },
                              (v103/*:: as any*/),
                              (v104/*:: as any*/),
                              (v15/*:: as any*/),
                              (v105/*:: as any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v103/*:: as any*/),
                              (v104/*:: as any*/),
                              (v15/*:: as any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v31/*:: as any*/),
                                  (v5/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "actor",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v17/*:: as any*/),
                                  (v18/*:: as any*/),
                                  (v14/*:: as any*/),
                                  (v22/*:: as any*/),
                                  (v24/*:: as any*/),
                                  (v25/*:: as any*/),
                                  (v26/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v106/*:: as any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v106/*:: as any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*:: as any*/),
                              (v27/*:: as any*/),
                              (v106/*:: as any*/),
                              (v107/*:: as any*/),
                              (v108/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v28/*:: as any*/),
                            "type": "ConvertedFromDraftEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*:: as any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*:: as any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v111/*:: as any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v111/*:: as any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v112/*:: as any*/),
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v112/*:: as any*/),
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v113/*:: as any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v113/*:: as any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v114/*:: as any*/),
                            "type": "RelatesToAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v114/*:: as any*/),
                            "type": "RelatesToRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v116/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v116/*:: as any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v116/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v115/*:: as any*/),
                                "storageKey": null
                              },
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v124/*:: as any*/),
                              (v125/*:: as any*/),
                              (v126/*:: as any*/),
                              (v127/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v124/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v27/*:: as any*/),
                              (v16/*:: as any*/),
                              (v124/*:: as any*/),
                              (v128/*:: as any*/),
                              (v129/*:: as any*/),
                              (v82/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v130/*:: as any*/),
                            "type": "IssueCommentPinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v130/*:: as any*/),
                            "type": "IssueCommentUnpinnedEvent",
                            "abstractKey": null
                          },
                          (v131/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v4/*:: as any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v134/*:: as any*/),
              (v30/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTimelineUpdated",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "SubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v137/*:: as any*/),
                            "type": "UnsubscribedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v137/*:: as any*/),
                            "type": "MentionedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*:: as any*/),
                              (v15/*:: as any*/),
                              (v31/*:: as any*/),
                              (v16/*:: as any*/),
                              (v32/*:: as any*/),
                              (v33/*:: as any*/),
                              (v34/*:: as any*/),
                              (v35/*:: as any*/),
                              (v36/*:: as any*/),
                              (v37/*:: as any*/),
                              (v38/*:: as any*/),
                              (v39/*:: as any*/),
                              (v40/*:: as any*/),
                              (v41/*:: as any*/),
                              (v42/*:: as any*/),
                              (v43/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v6/*:: as any*/),
                                  (v31/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/),
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              (v47/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v16/*:: as any*/),
                                  (v48/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v49/*:: as any*/),
                              (v50/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v14/*:: as any*/),
                                      (v31/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v30/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v51/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  (v30/*:: as any*/),
                                  (v5/*:: as any*/),
                                  (v52/*:: as any*/),
                                  (v15/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v132/*:: as any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v53/*:: as any*/),
                              (v54/*:: as any*/),
                              (v55/*:: as any*/),
                              (v56/*:: as any*/),
                              (v57/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v30/*:: as any*/),
                                  (v6/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v14/*:: as any*/),
                                      (v30/*:: as any*/),
                                      (v7/*:: as any*/),
                                      (v31/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v58/*:: as any*/),
                                  (v59/*:: as any*/),
                                  (v60/*:: as any*/),
                                  (v61/*:: as any*/),
                                  (v15/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v139/*:: as any*/),
                              (v67/*:: as any*/)
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v139/*:: as any*/)
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v68/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v141/*:: as any*/),
                                "storageKey": null
                              },
                              (v76/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v78/*:: as any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v5/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v30/*:: as any*/),
                                          (v6/*:: as any*/),
                                          (v133/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*:: as any*/),
                                      (v79/*:: as any*/),
                                      (v134/*:: as any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  },
                                  (v138/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v135/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "ReopenedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v81/*:: as any*/),
                              (v135/*:: as any*/)
                            ],
                            "type": "LockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "UnlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "PinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "UnpinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v83/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "LabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v84/*:: as any*/),
                              (v85/*:: as any*/)
                            ],
                            "type": "RenamedTitleEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v83/*:: as any*/)
                            ],
                            "type": "UnlabeledEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v143/*:: as any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v143/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v7/*:: as any*/),
                                  (v24/*:: as any*/),
                                  (v26/*:: as any*/),
                                  (v25/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v90/*:: as any*/),
                              (v135/*:: as any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v6/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v91/*:: as any*/),
                              (v92/*:: as any*/),
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v141/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v144/*:: as any*/),
                            "type": "MilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v144/*:: as any*/),
                            "type": "DemilestonedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*:: as any*/),
                              (v15/*:: as any*/),
                              (v95/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v14/*:: as any*/),
                                  (v138/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v135/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  (v96/*:: as any*/),
                                  (v97/*:: as any*/),
                                  (v98/*:: as any*/),
                                  (v31/*:: as any*/),
                                  (v79/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v6/*:: as any*/),
                                      (v133/*:: as any*/),
                                      (v99/*:: as any*/),
                                      (v30/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v16/*:: as any*/)
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v145/*:: as any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v61/*:: as any*/),
                                  (v31/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v145/*:: as any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v141/*:: as any*/),
                                "storageKey": null
                              },
                              (v146/*:: as any*/),
                              (v104/*:: as any*/),
                              (v15/*:: as any*/),
                              (v105/*:: as any*/)
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v146/*:: as any*/),
                              (v104/*:: as any*/),
                              (v15/*:: as any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v31/*:: as any*/),
                                  (v5/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "actor",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v17/*:: as any*/),
                                  (v18/*:: as any*/),
                                  (v14/*:: as any*/),
                                  (v22/*:: as any*/),
                                  (v24/*:: as any*/),
                                  (v25/*:: as any*/),
                                  (v26/*:: as any*/),
                                  (v30/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v147/*:: as any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v147/*:: as any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v16/*:: as any*/),
                              (v135/*:: as any*/),
                              (v147/*:: as any*/),
                              (v107/*:: as any*/),
                              (v108/*:: as any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v136/*:: as any*/),
                            "type": "ConvertedFromDraftEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v149/*:: as any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v149/*:: as any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v150/*:: as any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v150/*:: as any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v152/*:: as any*/),
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v152/*:: as any*/),
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v153/*:: as any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v153/*:: as any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v154/*:: as any*/),
                            "type": "RelatesToAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v154/*:: as any*/),
                            "type": "RelatesToRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v156/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v156/*:: as any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v156/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v155/*:: as any*/),
                                "storageKey": null
                              },
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v157/*:: as any*/),
                              (v125/*:: as any*/),
                              (v126/*:: as any*/),
                              (v127/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v157/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/),
                              (v135/*:: as any*/),
                              (v16/*:: as any*/),
                              (v157/*:: as any*/),
                              (v128/*:: as any*/),
                              (v129/*:: as any*/),
                              (v82/*:: as any*/),
                              (v80/*:: as any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v158/*:: as any*/),
                            "type": "IssueCommentPinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v158/*:: as any*/),
                            "type": "IssueCommentUnpinnedEvent",
                            "abstractKey": null
                          },
                          (v138/*:: as any*/),
                          (v131/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "edges",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              (v30/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "327d7a25f6f7a434b4c1b6554dc4ec68",
    "metadata": {},
    "name": "IssueViewerSubscriptionTimelineSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "8533a27abf57172c8de3e4a440dd377f";

export default node;
